import { render, staticRenderFns } from "./AddLocationPage.vue?vue&type=template&id=21b508a2"
import script from "./AddLocationPage.vue?vue&type=script&lang=js"
export * from "./AddLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports